import { useEffect, useRef } from 'react';
import useMemberPersistentStorage from '@usas/ui-web/state/memberPersistentStorage/UseMemberPersistentStorage';
import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';
import { useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

const TAXONOMIES = ['MemberDetail'];
const SCOPE = 'Member';

const useMemberContextRoutes = () => {
  const location = useLocation();
  const { navRoutes } = useNavRoutes();
  const { getPersistentStorage, resetExpiration } = useMemberPersistentStorage();
  const { basePersonState, getBasePerson } = useBasePersonData();
  const { contextSecurityState, getContextSecurity } = useSecurityData();
  const loadingStatus = useRef('not started');

  useEffect(() => {
    resetExpiration();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const persistentStorage = getPersistentStorage();
    if (loadingStatus.current === 'not started') {
      getBasePerson(persistentStorage?.personId || '0');
      loadingStatus.current = 'getting base person';
    } else if (loadingStatus.current === 'getting base person' && basePersonState.isObjLoaded === true) {
      const ctxStatus = getContextSecurity(basePersonState.objData?.personId || '0', TAXONOMIES, SCOPE);
      loadingStatus.current = ctxStatus === 'sent' ? 'getting context security' : 'loaded';
    } else if (loadingStatus.current === 'getting context security' && contextSecurityState.isObjLoaded === true) {
      loadingStatus.current = 'loaded';
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePersonState, contextSecurityState]);

  return {
    isLoading: loadingStatus.current !== 'loaded',
    navRoutes
  };
};

export default useMemberContextRoutes;